// Customers GraphQL queries

import { gql } from "@apollo/client"

export const GET_CUSTOMERS = gql`
  query GetCustomers($fresh: Boolean) {
    getCustomers(fresh: $fresh) {
      id
      customerID
      customerName
      legalName
      status
      email
      phone1
      country
      city
      postalCode
      addressLine1
      currencyID
      terms
      customerClass
      taxZone
      locationName
    }
  }
`

export const GET_CUSTOMER_BY_ID = gql`
  query GetCustomerById($customerID: String!, $fresh: Boolean) {
    getCustomerById(customerID: $customerID, fresh: $fresh) {
      id
      customerID
      customerName
      legalName
      status
      email
      phone1
      country
      city
      postalCode
      addressLine1
      currencyID
      terms
      customerClass
      taxZone
      locationName
      # Add WriteOffLimit if part of Customer GQL type
    }
  }
`
